import { IPlatformToolsAnalyticsTracker } from '@jetslash/market-frontend-shared-core/src/types/platform';
import { track } from '@/utility/eventTracking/eventTracker';

const useAnalyticsTrackingProvider = (): IPlatformToolsAnalyticsTracker => ({
  track,
});

export default useAnalyticsTrackingProvider;
